<template>
    <div class="uploader">
        <div class="images-preview" v-show="images.length">
            <div class="image-wrapper" v-for="image in images" :key="image.id">
                <div class="image">
                    <img v-img-secure="image['full_path']" src="" alt=""/>
                </div>
				<button class="delete-button" @click.stop="imageDeleteDialog = true; clickedImage = image">
					<i class="fa fa-times"></i>
				</button>
            </div>
        </div>
		<div class="upload-control">
			<label
				for="file"
				slot="upload-label"
				class="label"
				@click="openSelectionDialog"
				:class="{ 'label-disabled' : (maximumImages && images.length >= maximumImages) }">Upload
			</label>
		</div>

		<image-uploader
			ref="file"
			id="file"
			class="file"
			:debug="0"
			:maxWidth="1024"
			:maxHeight="1024"
			outputFormat="blob"
			:preview="false"
			accept="image/*"
			@input="addImage"
		></image-uploader>

		<template v-if="messages">
			<div class="message-box" :class="messages.class">
				<template v-if="messages.errors">
					<ul v-if="typeof messages.errors === 'object'">
						<li v-for="item in messages.errors">
							<span class="text-error">
								{{ item[0] ? item[0] : item }}
								<i v-show="messages.class === 'message-box-error'" class="fa fa-times-circle"></i>
							</span>
						</li>
					</ul>
					<span v-else>
						{{ messages.errors }}
						<i v-show="messages.class === 'message-box-error'" class="fa fa-times-circle"></i>
					</span>
				</template>
				<span v-if="messages.message">
					{{ messages.message }}
					<i v-show="messages.class === 'message-box-success'" class="fa fa-check-circle"></i>
				</span>
				<img v-show="messages.spinner" src="~@/assets/images/spinner-small.gif">
			</div>
		</template>

		<v-dialog v-model="imageDeleteDialog" persistent max-width="290">
			<v-card class="dialog" v-if="clickedImage">
				<v-card-title class="headline">Afbeelding verwijderen</v-card-title>
				<v-card-text>Weet je zeker dat je deze afbeelding wilt verwijderen?</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn flat @click.native="imageDeleteDialog = false; clickedImage = null;">Annuleren</v-btn>
					<v-btn color="red darken-1" flat
						   @click.native="imageDeleteDialog = false; deleteImage(clickedImage);  clickedImage = null;">
						Verwijderen
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="photoSelectionDialog" persistent max-width="290">
			<v-card class="dialog">
				<v-card-title class="headline">Afbeelding uploaden</v-card-title>
				<v-card-text>Selecteer één van de onderstaande opties:</v-card-text>
				<div class="button-group">
					<v-btn flat @click.native="getCamera(0); photoSelectionDialog = false;">Maak een foto</v-btn>
					<v-btn flat @click.native="getCamera(1); photoSelectionDialog = false;">Foto bibliotheek</v-btn>
					<v-btn flat @click.native="photoSelectionDialog = false;">Annuleren</v-btn>
				</div>
			</v-card>
		</v-dialog>
    </div>
</template>


<script>
    import DeviceService from '../services/DeviceService'
	import ImageUploader from 'vue-image-upload-resize'
	import 'blueimp-canvas-to-blob'

    export default {
        name: "ImageGallery",
		components: { ImageUploader },
        props: {
            deviceId: {
                type: String,
                required: true
            },
            deviceImages: {
                type: Array,
                default: () => []
            },
            maximumImages: {
                type: Number,
                default: null
            },
			messageTimeout: {
            	type: Number,
				default: 4000
			}
        },
        data() {
            return {
                images: [],
                files: [],
				messages: null,
				timeout: null,
				imageDeleteDialog: false,
				photoSelectionDialog: false,
				clickedImage: null
            }
        },
        mounted() {
            this.images = [...this.deviceImages];
        },
        methods: {
			openSelectionDialog(e) {
				if(device.platform === 'Android' || device.platform === 'iOS') {
					e.preventDefault()
					this.photoSelectionDialog = true
				}
			},
			getCamera(selectionIndex) {
        		const sourceType = (selectionIndex === 0) ?
					navigator.camera.PictureSourceType.CAMERA :
					navigator.camera.PictureSourceType.PHOTOLIBRARY

				const cameraOptions = {
					quality: 100,
					sourceType,
					destinationType: navigator.camera.DestinationType.FILE_URI,
					encodingType: navigator.camera.EncodingType.JPEG,
					mediaType: navigator.camera.MediaType.PICTURE,
					allowEdit: true,
					targetWidth: 1024,
					targetHeight: 1024
				};

				navigator.camera.getPicture((imageData) => {
					window.resolveLocalFileSystemURL(imageData, entry => {
						entry.file(file => this.$refs.file.handleFile(file));
					})
				}, (error) => {
					console.log(error)
				}, cameraOptions);
			},
            async addImage(file) {
				this.popupMessage({ message: 'Afbeelding upload wordt verwerkt...', spinner: true })
                const response = await this.upload(file);
            },
            async upload(file) {
                const formData = new FormData();
                formData.append('image', file, file.name);
                return DeviceService.uploadDeviceImage(this.deviceId, formData).then((response) => {
					this.popupMessage({ ...response, class: 'message-box-success' }, this.messageTimeout)
					this.$refs.file.$el.children[1].value = "";
                    this.images = [...this.images, response.data];
                    this.$store.dispatch('updateDevice', {
                        id: this.deviceId,
                        data: {
                            images: this.images
                        },
                    });
                }, (error) => {
					console.log(error);
					this.$refs.file.$el.children[1].value = "";
					this.popupMessage({ ...error.response.data, class: 'message-box-error' }, this.messageTimeout)
                });
            },
            deleteImage(image) {
				this.popupMessage({ message: "Afbeelding verwijderen wordt verwerkt...", spinner: true})
				return DeviceService.deleteDeviceImage(this.deviceId, image['id'])
					.then((response) => {
						this.popupMessage({ ...response, class: 'message-box-success' }, this.messageTimeout)
						this.images = this.images.filter(item => item['id'] !== image['id']);
						this.$store.dispatch('updateDevice', {
							id: this.deviceId,
							data: {
								images: this.images
							},
						});
					}, (error) => {
						console.log(error)
						this.$refs.file.value = '';
						this.popupMessage({ ...error.response.data, class: 'message-box-error' }, this.messageTimeout)
					});
            },
			popupMessage(message, timer = null) {
				this.messages = message;
				if(this.timeout) clearTimeout(this.timeout)
				if(timer)
					this.timeout = setTimeout(() => {
						this.messages = null
					}, timer)
			}
		},
    }
</script>

<style scoped>
	.file  {
		display: none;
	}

	.button-group {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

    .uploader {
		width: 100%;
		background: white;
		text-align: center;
		border-radius: 4px;
		border: 1px solid #dbdbdb;
		/*position: relative;*/
		-webkit-box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
		-moz-box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
		box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
	}

	.uploader .upload-control {
		/*position: absolute*/
		/*bottom: 0;*/
		/*left: 0;*/
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		background: white;
		border-top-left-radius: 4px;
		-webkit-border-top-left-radius: 4px;
		border-top-right-radius: 4px;
		-webkit-border-top-right-radius: 4px;
		padding: 1rem;
		text-align: center;
		/*border-bottom: 1px solid #dbdbdb*/
		-webkit-box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
		-moz-box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
		/*box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1)*/
	}

	.uploader .upload-control .label {
		padding: 1rem 2rem;
		background: #f18e00;
		color: white;
		border: 1px solid #dbdbdb;
		border-radius: 4px;
		font-size: 15px;
		font-weight: 700;
		-moz-user-select: none;
		-ms-user-select: none;
		-webkit-user-select: none;
		-webkit-touch-callout: none;
	}

	.uploader .upload-control .label-disabled {
		background-color: #f5f5f5;
		border-color: #dbdbdb;
		color: #7a7a7a;
		box-shadow: none;
		pointer-events: none;
		font-weight: 400;
	}
            /*.file-upload*/
                /*width: 200px*/
                /*margin: auto*/
                /*height: 68px*/
                /*position: relative*/

            /*input*/
            /*    display: none*/
            /*    opacity: 0*/
            /*    z-index: -1*/

	.uploader .images-preview {
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 40px;
		justify-content: left;
		padding: .5rem;
	}

	.uploader .image-wrapper {
		width: calc(33% - (4px * 2 / 3));
		margin: 2px;
		height: auto;
		position: relative;
		display: flex;
		flex-direction: column;
		background: white;
	}

	.uploader .image-wrapper:nth-child(3n) {
		margin-right: 0;
	}

	.uploader .image-wrapper:before {
		content: '';
		display: block;
		width: 100%;
		padding-bottom: 100%;
	}
	.uploader .image-wrapper .image {
		position: absolute;
		width: 100%;
		height: 100%;
		overflow: hidden;
	}

	.uploader .image-wrapper .image:before {
		content: '';
		position: absolute;
		display: block;
		width: 2rem;
		height: 2rem;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background-image: url('~@/assets/images/spinner-small.gif');
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}

	.uploader .image-wrapper .image img {
		position: relative;
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
		object-position: center center;
		z-index: 1;
	}

	.uploader .image-wrapper .delete-button {
		background: #f18e00;
		outline: none;
		color: white;
		position: absolute;
		top: 5px;
		right: 5px;
		border-radius: 50%;
		width: 30px;
		height: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 1;
	}
	.uploader .image-wrapper .delete-button button:focus {
		outline: none;
		background: lightgrey;
	}
	.uploader .message-box {
		padding-top: 1rem;
		padding-bottom: 1rem;
		display: flex;
		align-items: center;
		word-break: break-word;
		justify-content: center;
	}
	.uploader .message-box img {
		margin-left: .5rem;
		width: 20px;
		height: 20px;
	}
	.uploader .message-box.message-box-success {
		border-color: #48c774;
		background-color: #effaf3;
		color: #257942;
	}
	.uploader .message-box.message-box-error {
		border-color: #f14668;
		background-color: #feecf0;
		color: #cc0f35;
	}
	.uploader .message-box ul {
		list-style-type: none;
		padding: 0;
	}
			/*.text-success*/
			/*	color: green*/

			/*.text-error*/
			/*	color: red*/

</style>
